import * as React from 'react'
import PickingListRow from './PickingListRow'
import { PickingListRowShape, StagedPick } from '../../api/api_data_types'
import pickingListRemainingQuantity from './pickingListRemainingQuantity'

interface PickingListTableViewProps {
  data?: PickingListRowShape[]
  currentUser: { username: string }
  isLoading: boolean
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
}

export default function PickingListTableView({
  data,
  currentUser,
  isLoading,
  changedQuantities,
  setChangedQuantities,
}: PickingListTableViewProps) {
  const copyAllQuantities = () => {
    const newChangedQuantities = { ...changedQuantities }
    data?.forEach((row) => {
      if (row.row_type !== 'calculation') return

      const itemId = row.item?.id
      if (row.submitted || itemId == null) return

      const remainingQuantity = pickingListRemainingQuantity(row)

      if (remainingQuantity > 0) {
        newChangedQuantities[row.key] = {
          item_no: row.item_no,
          quantity: remainingQuantity,
          item_id: itemId,
        }
      } else {
        delete newChangedQuantities[row.key]
      }
    })
    setChangedQuantities(newChangedQuantities)
  }

  return (
    <div className="picking-list-table">
      {isLoading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      )}
      {data && (
        <table className="table">
          <thead>
            <tr>
              <th>Vare</th>
              <th>Placering Øst</th>
              <th>Placering Vest</th>
              <th>Lokation</th>
              <th>Antal</th>
              <th>
                <i
                  className="fa fa-icon fa-arrow-left cursor-pointer"
                  onClick={copyAllQuantities}
                  title="Kopier alle resterende antal"
                />
              </th>
              <th>Forkalk. antal</th>
              <th>Efterkalk. antal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <PickingListRow
                row={row}
                key={row.key}
                currentUser={currentUser}
                changedQuantities={changedQuantities}
                setChangedQuantities={setChangedQuantities}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
